export default "__VITE_ASSET__2170abda__"